import { useParams } from "react-router-dom";
import { SiteHeader } from "../platform/PlatformChrome";
import { Footer } from "../landing/Footer";
import { ArticleView } from "./ArticleView";

/**
 * Full-page article read. Articles always navigate (no modal layer): one
 * destination, deep-linkable, share-friendly.
 *
 * Public surface adds <SiteHeader /> and <Footer/>; dashboard surface relies on
 * DashboardLayout's outlet for chrome.
 *
 * Body content is centered with max-w-[760px] for a comfortable reading
 * measure (~65 chars at the body type size). Container padding scales
 * 1.25rem → 2.5rem → 4rem across mobile/tablet/desktop via .container-edit.
 */

interface ArticlePageProps {
  surface: "public" | "dashboard";
}

export function ArticlePage({ surface }: ArticlePageProps) {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return (
      <main className="container-edit pt-32 pb-20">
        <p className="font-display-italic text-[var(--color-ink-mute)]">No article specified.</p>
      </main>
    );
  }

  if (surface === "public") {
    return (
      <>
        <SiteHeader />
        <main className="pt-28 sm:pt-32 pb-20 sm:pb-24">
          <div className="container-edit max-w-[760px]">
            <ArticleView slug={slug} basePath="/news" eventBasePath="/calendar" />
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <div className="container-edit max-w-[760px]">
      <ArticleView
        slug={slug}
        basePath="/dashboard/articles"
        eventBasePath="/dashboard/calendar"
      />
    </div>
  );
}
